import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import PhotoSearchCard from '../../PhotoSearchCard';
import {
  selectRecoveryAccountAction
} from '../../../redux/actions/accountRecovery.actions';
import './styles.scss';

export class ConfirmAccountRecoveryPage extends React.Component {
  render() {
    const { matchedAccounts } = this.props.accountRecovery;

    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">
        <div className="col-lg-4 text-center">
          <h3 id="sign-in-brand"><Translate id="RecoverAccount" /></h3>
          <p>Choose the account that belongs to you:</p>
          <br/>
          <div className="row align-items-center justify-content-center scroll-overflow">
            <div className="col-lg-12 text-center">
              {matchedAccounts.map(profile => (
                <div
                  key={profile.id}
                  onClick={() => this.props.selectRecoveryAccountAction(profile)}
                >
                  <PhotoSearchCard
                    rowItem={profile}
                    isUserLoggedIn={false}
                    showAdd={false}
                    showRemove={false}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ accountRecovery }) => ({ accountRecovery });

export default withRouter(
  connect(
    mapStateToProps,
    { selectRecoveryAccountAction }
  )(ConfirmAccountRecoveryPage)
);


// WEBPACK FOOTER //
// ./src/components/pages/ConfirmAccountRecoveryPage/ConfirmAccountRecoveryPage.jsx